import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgDeveloperConsole = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "-4 -4 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.97788 6.11212C3.8797 6.14904 4.72575 8.10635 4.72574 8.54951V9.91594V14.643C4.72574 15.3816 5.5605 15.7879 5.97788 15.8987C6.15838 15.9725 6.79687 16.0759 7.90687 15.8987C9.29438 15.6771 17.8225 16.1572 18.8716 16.1202C19.9207 16.0833 20.4621 15.6771 20.9359 15.3078C21.4097 14.9385 21.0036 9.10348 20.9359 7.5524C20.8682 6.00133 20.0899 6.11212 19.413 6.11212H16.5703C15.1828 6.11212 8.07607 6.07519 5.97788 6.11212Z",
			fill: "fill"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9837 7.81836C12.3473 10.2706 12.0777 10.6902 11.2788 14.1584",
			stroke: "stroke",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5277 15.8973C3.5277 15.1615 3.774 12.1055 3.65085 9.87928C3.55233 8.09832 3.65085 6.6817 3.65085 6.24948C3.65085 5.81727 3.56586 5.06757 4.68301 5.03518C6.07946 4.99471 11.3097 5.15662 14.7906 5.03518C17.5754 4.93804 18.9497 5.00587 19.4084 5.04635C19.8132 5.07333 20.6186 5.35397 20.6024 6.26065C20.5822 7.39399 20.7746 9.12867 20.6024 11.4092C20.5196 12.5071 20.6024 15.5834 20.6024 15.9085M3.5277 15.8973C3.64337 15.8973 4.87384 15.825 7.82869 15.9085C10.7835 15.992 12.5126 16.0184 15.4662 15.9085C18.4198 15.7986 18.3762 15.9638 20.6024 15.9085M3.5277 15.8973C2.98859 15.8623 1.99334 15.8889 2.00003 16.5006C2.00672 17.1123 2.48577 19.0156 3.23458 19.0763C3.9834 19.137 9.74588 19.1571 11.3447 19.1571C12.9435 19.1571 18.5956 19.1976 19.142 19.1571C19.6884 19.1167 21.0913 19.1259 21.3408 18.9232C21.5904 18.7205 22.3203 17.8521 22.34 16.6674C22.3598 15.4828 21.2497 15.9085 20.6024 15.9085",
			stroke: "stroke",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8447 17.5996C11.9829 17.5996 12.2996 17.5996 12.4407 17.5996",
			stroke: "stroke",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.53667 8.91895C9.41711 8.94604 7.23393 10.3289 7.26199 10.8688C7.29005 11.4087 9.2376 12.8011 9.38714 12.8011",
			stroke: "stroke",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0356 8.95117C15.1454 8.97665 17.1598 10.0373 17.2006 10.6323C17.2414 11.2272 15.1731 12.8012 15.0358 12.8012",
			stroke: "stroke",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDeveloperConsole;
